import { FeatureFlagConfig } from '../../models/feature-flag-config/feature-flag-config.model';
import { FEATURE_FLAG } from './feature-flag.token';

export const defaultFlags: Required<FeatureFlagConfig> = {
    safeRoadsRebranding: false,
    driverChangeFileUpload: false,
};

export const provideFeatureFlag = (config?: FeatureFlagConfig) => {
    return {
        provide: FEATURE_FLAG,
        useValue: { ...defaultFlags, ...(config ?? {}) },
    };
};
